import { Product } from "@/types/types.ts";
import { useEffect, useState } from "react";
import { isMadeToMeasure } from "@/utils/product/isMadeToMeasure.ts";
import { isPerMetre } from "@/utils/product/isPerMetre.ts";
import { isInStoreOnly } from "@/utils/variant/isInStoreOnly.ts";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE } from "@/constants/constants.ts";

export const useUserAcknowledgementSatisfied = (product: Product) => {
  const [userAcknowledgementChecked, setUserAcknowledgementChecked] =
    useState<boolean>(false);
  const { variant } = useVariant(product);

  const isInStoreOnlyVariant = isInStoreOnly(variant);
  const userAcknowledgementRequired =
    !isInStoreOnlyVariant &&
    (product?.termsAndConditions?.customerConfirmationRequired ||
      isMadeToMeasure(product) ||
      isPerMetre(product));

  useEffect(() => {
    const handleUserAcknowledgement = (event: CustomEvent) => {
      const { userAcknowledgementChecked } = event.detail;
      setUserAcknowledgementChecked(userAcknowledgementChecked);
    };

    window.addEventListener(
      ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE,
      handleUserAcknowledgement,
    );

    return () => {
      window.removeEventListener(
        ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE,
        handleUserAcknowledgement,
      );
    };
  }, []);

  if (!userAcknowledgementRequired) {
    return true;
  }

  return userAcknowledgementChecked;
};
